import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonTheme } from "common/components/button/constants";
import { FilterBarComplexFilterEl } from "common/components/filter-bar/complex-filter";
import { FilterBarSimpleFilterEl } from "common/components/filter-bar/simple-filter";
import { InputEl } from "common/components/input";
import { InputSize } from "common/components/input/types";
import { SelectEl } from "common/components/select";
import { SvgIconEl } from "common/components/svg-icon";
import { TooltipEl } from "common/components/tooltip";
import { Placement } from "common/components/tooltip/types";
const SimpleActionButton = ({ comp, actionOption }) => {
  const toolTipMaxWidthStyle = actionOption.toolTipMaxWidthStyle ? actionOption.toolTipMaxWidthStyle : `150px`;
  return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(ButtonEl, {
    sel: ".action",
    key: JSON.stringify(actionOption),
    attrs: {
      theme: comp.attr(`action-button-theme`) || ButtonTheme.Tertiary,
      role: `button`,
      tabindex: 0,
      disabled: actionOption.disabled,
      elref: actionOption.eventName,
      type: actionOption.type,
      icon: actionOption.icon,
      href: actionOption.href,
      target: actionOption.target
    },
    on: {
      click: actionOption.disabled ? null : () => comp.helpers.handleClickAction(actionOption.eventName)
    }
  }, actionOption.label), actionOption.disabledTooltip && actionOption.disabled ? /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Bottom, "max-width": toolTipMaxWidthStyle }
  }, actionOption.disabledTooltip) : actionOption.tooltip && /* @__PURE__ */ jsx(TooltipEl, {
    attrs: { placement: Placement.Bottom, "max-width": toolTipMaxWidthStyle }
  }, actionOption.tooltip));
};
const MultipleActionButton = ({ comp, actionOption }) => /* @__PURE__ */ jsx(SelectEl, {
  sel: ".action",
  key: JSON.stringify(actionOption),
  attrs: {
    icon: { leftIcon: actionOption.icon },
    "selected-option": actionOption.label,
    sections: actionOption.sections,
    "menu-width": actionOption.menuWidth || 200,
    "menu-height": actionOption.menuHeight || 300,
    elref: actionOption.eventName
  },
  on: {
    change: (ev) => comp.helpers.handleClickAction(actionOption.eventName, ev.detail.item)
  }
});
const ItemFilter = ({ comp, filterSelectConfig }) => {
  const simpleFilterMaxWidth = `${Math.floor(100 / comp.attr(`filters`).length) - 5}%`;
  return filterSelectConfig.filterType === comp.helpers.FilterType.Complex ? /* @__PURE__ */ jsx(FilterBarComplexFilterEl, {
    attrs: {
      sections: filterSelectConfig.sections
    },
    on: {
      changeFilter: comp.helpers.handleFilterChanged,
      menuChange: (ev) => {
        comp.helpers.handleMenuChange(ev, filterSelectConfig.name);
      }
    }
  }) : /* @__PURE__ */ jsx(FilterBarSimpleFilterEl, {
    class: {
      "filter-option": true,
      [filterSelectConfig.name]: true
    },
    attrs: {
      name: filterSelectConfig.name,
      multiple: filterSelectConfig.multiple,
      "apply-button": filterSelectConfig.applyButton,
      label: comp.helpers.getFilterSelectedLabel(filterSelectConfig),
      sections: filterSelectConfig.sections,
      "no-filter-label": filterSelectConfig.noFilterLabel,
      "menu-width": filterSelectConfig.menuWidth || 200,
      theme: filterSelectConfig.theme
    },
    on: {
      changeFilter: comp.helpers.handleFilterChanged,
      applyFilter: comp.helpers.handleFilterApplyClicked,
      menuChange: (ev) => {
        comp.helpers.handleMenuChange(ev, filterSelectConfig.name);
      }
    },
    style: {
      "max-width": simpleFilterMaxWidth
    }
  });
};
export function template() {
  const { searchText } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".filter-bar",
    class: { "search-first": this.attr(`search-first`) },
    attrs: { part: `filter-bar-root` }
  }, this.attr(`selected-count`) > 0 || this.attr(`always-show-count`) ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".selected-count",
    attrs: { elref: `selectedCount` },
    on: { click: this.helpers.handleClearSelected }
  }, /* @__PURE__ */ jsx("div", {
    sel: ".results"
  }, this.helpers.getSelectedCountLabel()), this.attr(`selected-count`) > 0 && /* @__PURE__ */ jsx("div", {
    sel: ".x-button-wrap"
  }, /* @__PURE__ */ jsx(SvgIconEl, {
    attrs: { icon: `x` }
  }))), /* @__PURE__ */ jsx("div", {
    sel: ".action-section"
  }, this.attr(`actions`).map((actionOption) => /* @__PURE__ */ jsx("div", {
    sel: ".action-container"
  }, `sections` in actionOption && actionOption.sections.length > 0 ? /* @__PURE__ */ jsx(MultipleActionButton, {
    comp: this,
    actionOption
  }) : /* @__PURE__ */ jsx(SimpleActionButton, {
    comp: this,
    actionOption
  }))))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".filtered-count"
  }, /* @__PURE__ */ jsx("div", {
    sel: ".results",
    attrs: { elref: `resultCount` }
  }, this.attr(`result-count`))), /* @__PURE__ */ jsx("div", {
    sel: ".filter-by-text",
    class: { hidden: this.helpers.isFilterSectionHidden() || this.attr(`hide-filter-by-text`) }
  }, "Filter by"), /* @__PURE__ */ jsx("div", {
    sel: ".filter-options"
  }, this.attr(`filters`).map((filterSelectConfig) => /* @__PURE__ */ jsx(ItemFilter, {
    comp: this,
    filterSelectConfig
  })))), /* @__PURE__ */ jsx("div", {
    sel: ".filter-right-side"
  }, !this.attr(`hide-reset-filters`) && this.helpers.isFilterSelected() ? /* @__PURE__ */ jsx("div", {
    sel: ".reset-filter-button",
    on: { click: this.helpers.handleFilterReset }
  }, "Reset Filter") : null, /* @__PURE__ */ jsx("slot", {
    attrs: { name: `filter-actions` }
  }), !this.attr(`hide-search`) ? /* @__PURE__ */ jsx(InputEl, {
    sel: ".search-input",
    attrs: {
      icon: `search`,
      placeholder: this.attr(`search-placeholder`),
      size: InputSize.Medium,
      value: searchText,
      elref: `searchInput`,
      "show-clear": true
    },
    style: { width: `${this.helpers.getTextWidth()}px` },
    props: {
      maxLength: 50,
      value: searchText
    },
    on: {
      blur: () => this.helpers.handleInputExpanded(false),
      clear: () => this.helpers.handleUpdateInput(``),
      focusin: () => this.helpers.handleInputExpanded(true),
      input: (ev) => this.helpers.handleUpdateInput(ev.target.value)
    }
  }) : null));
}
